import { alpha, Box, Card, styled } from '@mui/material';
import { config } from 'public/styles';

export const StyledIdScanCard = styled(Card)<{ image?: string }>(({ theme, image }) => ({
  backgroundImage: image ? `url(data:image/jpeg;base64,${image})` : undefined,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  padding: theme.spacing(8),
  borderRadius: 24,
  backgroundColor: theme.palette.background.paper,
  width: '400px',
  height: '230px',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  justifyContent: 'space-between',
  position: 'relative',
  overflow: 'hidden',

  '&:hover': {
    cursor: 'pointer',
    boxShadow: `0px 0px 0px 8px ${alpha(config.colors.primary, 0.3)}`,

    '& .hover-overlay': {
      opacity: 1,
    },

    '& .hover-pill': {
      opacity: 1,
      transform: 'translate(-50%, 0)',
    },
  },

  '& .hover-pill-mobile': {
    opacity: 1,
    transform: 'translate(-50%, 0)',
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '220px',
  },
}));

export const HoverOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(4),
  backgroundColor: alpha(config.colors.primary, 0.3),
  color: config.colors.text.primary,
  fontFamily: config.fontFamily,
  fontWeight: 600,
  opacity: 0,
  transition: 'opacity 0.3s ease',
  pointerEvents: 'none',
}));

export const HoverPill = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(4),
  left: '50%',
  transform: 'translate(-50%, 150%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  padding: theme.spacing(2, 5),
  borderRadius: 999,
  backgroundColor: config.colors.primary,
  color: config.colors.text.primary,
  fontFamily: config.fontFamily,
  opacity: 0,
  transition: 'transform 0.3s ease, opacity 0.3s ease',
  pointerEvents: 'none',
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(6),
}));

export const StyledTextPlaceholder = styled(Box)<{
  width: string;
  height: string;
}>(({ width, height, theme }) => ({
  width,
  height,
  backgroundColor: theme.palette.lwBlack[10],
  borderRadius: 4,
}));
